export const SEMANTIC_MODEL_CLASS_PROFILE = "class-profile";
export function isSemanticModelClassProfile(entity) {
    return entity?.type.includes(SEMANTIC_MODEL_CLASS_PROFILE) ?? false;
}
//# sourceMappingURL=class-profile.js.map